import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ProjectService } from "../services/projectservice.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ConfirmationDialogComponent } from "src/app/components/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { HeaderComponent } from "src/app/components/header/header.component";
import { InfoDialogComponent } from "src/app/components/info-dialog/info-dialog.component";
import { UserRoles } from "src/app/enums/userRoles.enum";
import { OrganizationService } from "src/app/services/Organization/organization.service";
import { catchError } from "rxjs/operators";
import { forkJoin, of, throwError } from "rxjs";
import { AuthServiceService } from "src/app/services/auth-service.service";
import { IctprojectService } from "../services/ictproject.service";
import { ProjectServiceService } from "src/app/services/project-service.service";
import { UntypedFormControl } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
declare var $: any;
@Component({
  selector: "app-projects-list",
  templateUrl: "./projects-list.component.html",
  styleUrls: ["./projects-list.component.css"],
})
export class ProjectsListComponent implements OnInit {
  public allProjects: any = [];
  public size = 10;
  public from = 0;
  public organizationName: string;
  public loading = false;
  public projectType = 1;
  public search: UntypedFormControl;
  public searchText: any;

  public permissions = {
    canUpdateProject: false,
    canDeleteProject: false,
    canViewProject: true,
    canAddProject: false,
  };

  public ictPermissions = {
    canAddProject: false,
    canUpdateProject: false,
    canDeleteProject: false,
    canViewProject: true,
    canApproveProject: false,
  };

  @ViewChild(HeaderComponent) header: HeaderComponent;
  @ViewChild("actions") actions: ElementRef;
  @ViewChild("searchTerm") searchTerm: ElementRef;
  private searchValue: string;
  deleteList: any[] = [];
  currentDocuments: any = [];
  selectedProject = 1
  canAddProject = false;
  projectGridViews: { id: any; name: any }[];
  selectedView: { id: number; name: string };
  showFilterOptions: boolean;
  isFilterByUser = true;
  userEmail: string;
  projectCount: any;
  pages: any;
  throttle = 0;
  distance = 2;
  currentPage: any;
  lastPage: number;
  firstPage: number;
  organizations: any;
  userRole: string = this.auth.getRole();
  userOrgID: string = this.auth.getOrganizationId();
  userOrgName: string = this.auth.getOrganizationName();
  contentTypes = [
    "Case Studies",
    "Corporate Deck",
    "Industry Deck",
  ];
  contentType: any;
  isSelectAll: boolean = false;

  selectedorganization: any = { id: this.userOrgID, name: this.userOrgName };
  selectedDelete: boolean = false;
  constructor(
    private organizationService: OrganizationService,
    private auth: AuthServiceService,
    private projectService: ProjectService,
    // tslint:disable-next-line: align
    private router: Router,
    private cd: ChangeDetectorRef,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    // tslint:disable-next-line: align
    private projectDataService: ProjectServiceService,
    private ictProjectService: IctprojectService,
    private toastr: ToastrService
  ) {
    this.lastPage = 5;
    this.firstPage = 0;
  }

  ngOnInit() {
    this.searchText = "";
    this.userEmail = this.auth.getEmailId();
    if (
      this.projectDataService.page &&
      this.projectDataService.page === "project-list"
    ) {
      this.from = this.projectDataService.from
        ? this.projectDataService.from
        : 0;
      this.size = this.projectDataService.size
        ? this.projectDataService.size
        : 10;
      this.currentPage = this.projectDataService.currentPage
        ? this.projectDataService.currentPage
        : 1;
    } else {
      this.from = 0;
      this.size = 10;
      this.currentPage = 1;
    }
    this.initilizeUserPermissions();
    this.search = new UntypedFormControl("");
  }
  ngAfterViewInit() {
    this.header.backgroundColor = true;
  }

  async initilizeUserPermissions() {
    this.loading = true;
    switch (this.auth.getRole()) {
      case UserRoles.SuperAdmin:
        await this.organizationService
          .fetchOrganizationsList()
          .toPromise()
          .then((res) => {
            this.organizations = res;
            // tslint:disable-next-line: max-line-length
            const organization = this.organizations.find(
              (org) => org.id == this.auth.getOrganizationId()
            );
            if (organization) {
              this.selectedorganization =
                this.projectDataService.getOrganization("project-list");
              if (!this.selectedorganization) {
                this.selectedorganization = organization;
              }
            }

            // this.selectedorganization = this.organizations.splice(this.organizations.
            // indexOf(this.organizations.filter(org => org.id === localStorage.getItem('organizationId'))[0]), 1);
            // this.selectedorganization = this.selectedorganization[0];
          });
        // tslint:disable-next-line: max-line-length
        this.permissions.canDeleteProject =
          this.permissions.canViewProject =
          this.permissions.canUpdateProject =
          this.permissions.canAddProject =
          true;
        // tslint:disable-next-line: max-line-length
        this.ictPermissions.canDeleteProject =
          this.ictPermissions.canViewProject =
          this.ictPermissions.canUpdateProject =
          this.ictPermissions.canAddProject =
          true;
        break;
      case UserRoles.ContentManager:
        this.permissions.canUpdateProject = this.permissions.canAddProject =
          true;
        this.ictPermissions.canUpdateProject =
          this.ictPermissions.canAddProject = true;

        break;
      case UserRoles.Admin:
        // tslint:disable-next-line: max-line-length
        this.permissions.canViewProject =
          this.permissions.canDeleteProject =
          this.permissions.canUpdateProject =
          this.permissions.canAddProject =
          true;
        // tslint:disable-next-line: max-line-length
        this.ictPermissions.canViewProject =
          this.ictPermissions.canDeleteProject =
          this.ictPermissions.canUpdateProject =
          this.ictPermissions.canAddProject =
          true;

        break;
      case UserRoles.Viewer:
        break;
    }
    this.contentType = this.projectDataService.getSelectedContentType("project-list");
    // this.contentType = decodeURIComponent(this.contentType);
    if (!(this.contentType && this.contentType)) {
      this.contentType = this.contentTypes[0];
    }

    if (this.contentType !== "Case Studies") {
      this.getProjectsListWithContentType(this.contentType);
      this.onChangeContentType(this.contentType);
    } else {
      this.getProjectsListWithPagination();
    }
  }
  async getProjectsListWithContentType(contentType: string) {
    this.loading = true;
    if (this.isSelectAll) {
      if (this.iscomingfromsearch) {
        return
      }
      else {
        this.size = 1000;
      }
    }
    else {
      this.size = 10
    }
    await this.ictProjectService
      .getICTProjectsByContentType(contentType, this.from, this.size)
      .subscribe((response) => {
        this.loading = false;
        if (response) {
          this.allProjects = response.ictProjects;
          this.cd.detectChanges();
          this.assignPagesValues(this.allProjects.length);
        }

        this.loading = false;
      });
  }
  iscomingfromsearch: boolean = false;
  onScroll() {
    const organizationName = this.selectedorganization.name
    let totalFiles = this.from;
    if (this.from > (this.projectCount - 10)) {
      return
    }
    this.from += 10;
    if ((this.from + this.size) > this.projectCount) {
      this.size = this.projectCount - this.from;
    }
    if (this.from != totalFiles) {
      this.projectService.getAllProjects(this.from, this.size, organizationName).subscribe(res => {
        this.loading = false;
        const list = res.map((element) => {
          return element.fileInfo;
        })
        if (!this.iscomingfromsearch) {
          for (let i of list) {
            this.allProjects.push(i);
          }
        }

        this.cd.detectChanges();
      }, error => {
        this.allProjects = Object.assign([]);
        this.cd.detectChanges();
      });
    }
  }
  onScrolled(contentType: string) {
    //this.search.reset();
    this.contentType = contentType;
    let totalFiles = this.from;
    if (this.from > (this.projectCount - 10)) {
      return
    }
    this.from += 10;
    if ((this.from + this.size) > this.projectCount) {
      this.size = this.projectCount - this.from;
    }

    if (this.from != totalFiles) {
      this.ictProjectService.getICTProjectsByContentType(contentType, this.from, this.size).subscribe(res => {
        this.loading = false;
        if (res) {
          const list = res.map((element) => {
            return element.fileInfo;
          })
          if (!this.iscomingfromsearch) {
            for (let i of list) {
              this.allProjects.push(i);
            }
          }
          if (!this.iscomingfromsearch) {
            this.allProjects = this.allProjects.concat(res.ictProjects);
          }

          this.cd.detectChanges();
          this.assignPagesValues(res.ictProjectsCount);
        }
      }, error => {
        this.allProjects = Object.assign([]);
        this.cd.detectChanges();
      });
    }
  }

  async getProjectsListWithPagination() {
    this.loading = true;
    const organizationName = this.selectedorganization.name
      ? this.selectedorganization.name
      : this.auth.getOrganizationName();
    if (this.isSelectAll) {
      if (this.iscomingfromsearch) {

        return
      }
      else {
        this.size = 1000;
      }
    }
    else {
      this.size = 10
    }
    await forkJoin(
      this.projectService.getAllProjects(
        this.from,
        this.size,
        organizationName
      ),
      this.projectService.getProjectCount(organizationName),
      throwError("This will error").pipe(catchError((error) => of(error)))
    ).subscribe((responses) => {
      this.loading = false;
      if (responses[0]) {
        this.allProjects = responses[0].map((element) => {
          return element.fileInfo;
        });
        this.cd.detectChanges();
        if (this.isSelectAll) {
          for (let project of this.allProjects) {
            const a = this.deleteList.some(x => x == project.id);
            if (!a) {
              this.deleteList.push(project.id);
            }
          }
        }
      }
      if (responses[1]) {
        this.loading = false;
        this.assignPagesValues(responses[1]);
      }
      this.loading = false;
    });
  }

  getProjectsList() {
    this.loading = true;
    this.search.reset();
    const organizationName = this.selectedorganization.name
      ? this.selectedorganization.name
      : this.auth.getOrganizationName();

    this.projectService
      .getAllProjects(this.from, this.size, organizationName)
      .subscribe(
        (res) => {
          this.getprojectCount();
          this.loading = false;
          this.allProjects = res.map((element) => {
            return element.fileInfo;
          });
          this.cd.detectChanges();
        },
        (err) => {
          this.loading = false;
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: "280px",
            data: { message: err.message, class: "text-danger" },
          });
        }
      );
  }

  getprojectCount() {
    this.loading = true;
    const organizationId = this.selectedorganization.id
      ? this.selectedorganization.id
      : this.auth.getOrganizationId();
    this.projectService.getProjectCount(organizationId).subscribe(
      (response) => {
        this.loading = false;
        this.assignPagesValues(response);
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  editICTProject(attachment: any) {
    if (!attachment.isLocked) {
      // this.router.navigate(["/project/ICT/editICTProject/a/" + attachment.id]);

      this.router
        .navigate(["/Home/KMSPortal/Corporate Deck/edit" + attachment.id])
        .then(() => (this.loading = false));
    } else {
      const dialogRef = this.dialog.open(InfoDialogComponent, {
        width: "280px",
        data: {
          message:
            "Another version of this project has been in review to update. Please try again later.",
          class: "text-success",
        },
      });
    }
  }

  // assign pagination values
  assignPagesValues(projectCount: number) {
    this.projectCount = projectCount;
    this.pages = [];
    for (let i = 1; i < this.projectCount / this.size; i++) {
      this.pages.push(i);
    }
    this.pages.push(this.pages.length + 1);
  }

  loadMore(pageNumber) {
    if (this.currentPage === pageNumber) {
      return 1;
    }
    this.currentPage = pageNumber;
    if (pageNumber === 1) {
      this.from = 0;
    } else {
      this.from = --pageNumber * this.size;
    }

    if (this.currentPage === this.firstPage && this.firstPage > 1) {
      this.firstPage = this.firstPage - 1;
    }
    this.populateGrid(this.searchValue);
    this.projectDataService.setPageValues(
      this.from,
      this.size,
      this.currentPage
    );
    this.projectDataService.page = "project-list";
  }

  next() {
    if (this.from + this.size > this.projectCount) {
      return;
    }
    this.from = this.from + this.size;
    this.currentPage++;

    this.populateGrid(this.searchValue);

    if (this.projectCount / this.size > this.lastPage) {
      this.lastPage = this.lastPage + 1;
      this.firstPage = this.firstPage + 1;
    }
    this.projectDataService.setPageValues(
      this.from,
      this.size,
      this.currentPage
    );
    this.projectDataService.page = "project-list";
  }

  previous() {
    if (this.from === 0) {
      return;
    }
    this.from = this.from - this.size;
    this.currentPage--;
    if (this.firstPage !== 0) {
      this.lastPage = this.lastPage - 1;
      this.firstPage = this.firstPage - 1;
    }
    this.populateGrid(this.searchValue);
    this.projectDataService.setPageValues(
      this.from,
      this.size,
      this.currentPage
    );
    this.projectDataService.page = "project-list";
  }

  searchGrid() {
    if (this.searchText.trim()) {
      this.from = 0;
      this.size = 10;
      this.currentPage = 1;
    }
    this.populateGrid(this.searchText);
    this.iscomingfromsearch = true;
  }
  clearSearchText() {
    this.searchText = "";
    this.iscomingfromsearch = false;
    this.populateGrid(this.searchText);

  }

  populateGrid(searchTerm: string) {
    if (searchTerm !== undefined && searchTerm.trim()) {
      this.loading = true;
      this.searchValue = searchTerm;
      if (this.contentType !== "Case Studies") {
        this.ictProjectService
          .searchGridForApprovedICT(
            this.contentType,
            searchTerm,
            this.from,
            1000
          )
          .subscribe((res) => {
            this.loading = false;
            if (res) {
              this.allProjects = res.ictProjects;
              this.cd.detectChanges();
              this.assignPagesValues(res.ictProjectsCount);
            }

            this.loading = false;
          });
      } else {
        this.projectService
          .searchGridForApproved(
            searchTerm,
            this.selectedorganization.name,
            this.from,
            1000
          )
          .subscribe(
            (res) => {
              this.allProjects = res.projects;
              this.allProjects = this.allProjects.filter((ele) => ele.isActive);
              this.assignPagesValues(this.allProjects.length);
              this.loading = false;
            },
            (err) => {
              this.loading = false;
              const dialogRef = this.dialog.open(InfoDialogComponent, {
                width: "280px",
                data: { message: err.message, class: "text-danger" },
              });
            }
          );
      }
    } else {
      // this.getprojectCount();
      // this.getProjectsList();
      if (this.contentType !== "Case Studies") {
        this.getProjectsListWithContentType(this.contentType);
      } else {
        this.iscomingfromsearch = false;
        this.getProjectsListWithPagination();
      }
    }
  }
  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Backspace' && this.searchText.length === 1) {
      this.clearSearchText();
    }
  }
  handleFileInput(files, item) {
    const file = files.item(0);
    if (file) {
      if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
        // const dialogRef = this.dialog.open(t, {
        //   width: '280px',
        //   data: {
        //     message: 'File format is not supported. Please upload an Excel file.',
        //     class: 'text-danger',
        // this.t
        this.toastr.error("File format is not supported. Please upload an Excel file.");

      }
    }

    this.loading = true;
    const uploadService = (item === 'Case Studies') ? this.projectService :
      ((item === 'Others') ? this.ictProjectService : null);

    uploadService.uploadMultipleProjects(file).subscribe(
      (res) => {
        this.loading = false;
        this.toastr.success("Uploaded Successfully");

        if (this.contentType !== 'Case Studies' && this.contentType !== 'Others') {
          this.getProjectsListWithContentType(this.contentType);
        } else {
          this.getProjectsListWithPagination();
        }
      },
      (err) => {
        this.loading = false;
      }
    );
  }



  addProject() {
    //this.router.navigate(["project/addProject"]);
    this.router.navigate(["/Home/KMSPortal/Case Studies/Add"]);
  }
  


  navigate(Id, isView) {
   const params = isView
  ? { queryParams: { isView: true, isApproved: true } }
    : { queryParams: { isApproved: true } };
   
      if(this.contentType=="Industry Deck"||this.contentType=="Corporate Deck")
    {
   this.router.navigate([`/Home/KMSPortal/Project Content/View/${Id}`], params);
    }
    else
    {
      this.router.navigate([`/Home/KMSPortal/Project Content/ViewProject/${Id}`], params);
} 
    
   
  }

  deleteProject(projectId: any) {
    
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "350px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.data === "DELETE") {
        this.searchTerm.nativeElement.value = "";
        this.loading = true;
        this.projectService.deleteProject(projectId).subscribe(
          (res) => {
            this.loading = false;
            this.toastr.error("Selected Project Deleted Successfully")
            setTimeout(() => {
              if (this.contentType !== "Case Studies") {
                this.getProjectsListWithContentType(this.contentType);
              } else {
                this.getProjectsListWithPagination();
              }
            }, 1000);
          },
          (err) => {
            this.loading = false;
          }
        );
      }
    });
  }

  navigateToICT(Id, isView?) {
    // if(this.contentType=="Industry Deck")
    //   {
    //     this.router
    //   .navigate(["/Home/KMSPortal/Industry Deck/edit/" + Id])
    //   .then(() => (this.loading = false));
    //   }
    //   else{
    // this.router
    //   .navigate(["/Home/KMSPortal/Corporate Deck/edit/" + Id])
    //   .then(() => (this.loading = false));
    //   }
    this.router.navigate([`/Home/KMSPortal/Project Content/View/${Id}`],{
        // this.router.navigate([`/project/ICT/editICTProject/a/${Id}`], {
      queryParams: { isView },
    });
  }

  deleteICTProject(projectId) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "350px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.data === "DELETE") {
        this.loading = true;
        this.ictProjectService.deleteICTProjectById(projectId).subscribe(
          (res) => {
            this.toastr.error("Selected Project Deleted Successfully")
            this.loading = false;
            this.onChangeContentType(this.contentType);
            setTimeout(() => {
              if (this.contentType !== "Case Studies") {
                this.getProjectsListWithContentType(this.contentType);
              } else {
                this.getProjectsListWithPagination();
              }
            }, 1000);
          },
          (err) => {
            this.loading = false;
          }
        );
      }
    });
  }

  findChecked(id) {
    const index = this.deleteList.findIndex((ele) => ele === id);
    if (index >= 0) {
      return true;
    }
    return false;
  }

  async addToDeleteList(project, event) {
    if (event.checked) {
      await this.deleteList.push(project.id);
      if (this.deleteList.length > 0) {
        this.selectedDelete = true;
      }
      if (this.deleteList.length == this.projectCount) {
        this.isSelectAll = true;
      }
    } else {
      const index = this.deleteList.findIndex((ele) => ele === project.id);
      if (index >= 0) {
        await this.deleteList.splice(index, 1);
      }
      if (this.deleteList.length <= 0) {
        this.selectedDelete = false;
      }
      this.isSelectAll = false;
    }
    // if (this.deleteList.length > 0) {
    //   this.actions.nativeElement.style.right = "0px";
    // } else {
    //   this.actions.nativeElement.style.right = "-300px";
    // }
  }

  deleteMultipleProjects() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "300px",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.data === "DELETE") {
        this.loading = true;

        if (this.contentType === "Case Studies") {
          this.projectService.deleteMultipleProjects(this.deleteList).subscribe(
            (res) => {
              this.toastr.error("Selected Projects Deleted Successfully");
              this.loading = false;
              this.deleteList = [];
              this.actions.nativeElement.style.right = "-300px";
              setTimeout(() => {
                this.getProjectsListWithPagination();
              }, 500);
            },
            (err) => {
              this.loading = false;
            }
          );
        } else {
          this.ictProjectService
            .deleteMultipleICTProjects(this.deleteList)
            .subscribe(
              (res) => {
                this.toastr.error("Selected Projects Deleted Successfully");
                this.loading = false;
                this.deleteList = [];
                this.actions.nativeElement.style.right = "-300px";
                setTimeout(() => {
                  this.getProjectsListWithContentType(this.contentType);
                }, 500);
              },
              (err) => {
                this.loading = false;
              }
            );
        }
        this.isSelectAll = false;
        this.selectedDelete = false;
      }
    });
  }

  dismissSidebar() {
    $("#sidebar").removeClass("active");
    $("#sidebar_r").removeClass("active");
    $(".overlay").removeClass("active");
  }
  onChangeContentType(contentType) {
    this.isSelectAll = false;
    this.selectedDelete = false;
    this.deleteList = []
    this.resetPagination();
    this.contentType = contentType;
    this.projectDataService.page = "project-list";
    this.projectDataService.setSelectedContentType(contentType);
    if (contentType !== "Case Studies") {
      this.getProjectsListWithContentType(contentType);
    } else {
      // this.contentType = null;
      this.getProjectsListWithPagination();
    }
  }
  resetPagination() {
    this.currentPage = 1;
    this.from = 0;
    this.size = 10;
    this.lastPage = 5;
    this.firstPage = 0;
  }

  onChangeOrganization(orgValue) {
    this.resetPagination();
    this.search.reset();
    const org = this.organizations.find(
      (organization) => organization.id === orgValue
    );
    this.projectDataService.page = "project-list";
    this.projectDataService.setOrganization(org);
    if (org) {
      this.selectedorganization = org;
    }
    if (this.contentType !== "Case Studies") {
      this.getProjectsListWithContentType(this.contentType);
    } else {
      this.getProjectsListWithPagination();
    }
  }

  onChangeProjectType(val: any) {
    if (val == "Case Studies") {
      //this.router.navigate(["project/addProject"]);
      this.router.navigate(["/Home/KMSPortal/Project Content/AddProject"]);
    } else {
      this.router.navigate(["/Home/KMSPortal/Project Content/AddProj"]);
      // //this.router.navigate(["project/ICT/addICTProject"]);
      // if(this.contentType=="Industry Deck")
      //   {
      // this.router.navigate(['Home/KMSPortal/Industry Deck/Add']);
      //   }
      //   else{
      //     this.router.navigate(['Home/KMSPortal/Corporate Deck/Add']);
      //   }
    }
  }

  switchDeckView() {
    this.router.navigate(['/Home/KMSPortal'])
  }
  gotoHome() {
    this.router.navigate(['/Home'])
  }
  async selectAll(event) {
    if (event.target.checked) {
      this.isSelectAll = true;
      this.selectedDelete = true;
      this.assignPagesValues(this.projectCount);
      if (this.contentType !== "Case Studies") {
        await this.getProjectsListWithContentType(this.contentType);
      } else {
        await this.getProjectsListWithPagination();
        setTimeout(() => { }, 5000);
      }
      for (let project of this.allProjects) {
        this.deleteList.push(project.id)
      }
    }
    else {
      this.isSelectAll = false;
      this.selectedDelete = false;
      this.allProjects = [];
      this.deleteList = [];
      if (this.contentType !== "Case Studies") {
        await this.getProjectsListWithContentType(this.contentType);
      } else {
        await this.getProjectsListWithPagination();
      }
    }
  }
}
